export enum StreamChatEvent {
  MessageNew = 'message.new',
  MessageUpdated = 'message.updated',
  MessageDeleted = 'message.deleted',
  NotificationMessageNew = 'notification.message_new',
  NotificationMarkRead = 'notification.mark_read',
  NotificationMarkUnread = 'notification.mark_unread',
  NotificationRemovedFromChannel = 'notification.removed_from_channel'
}
